// removed by extract-text-webpack-plugin
module.exports = {"root":"_2b6uE7z","link":"_1_qWEhr","downRightArrowContainer":"gFbsoM9","downRightArrowSvg":"_1SFCJpa"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/SearchResultPage/components/SearchResultList/components/JobItem/components/JobLocation/JobLocation.less
 ** module id = 817
 ** module chunks = 0
 **/